import React, {useEffect} from 'react';
import { Form, Radio, Label, Input } from 'semantic-ui-react';
import {
  PAYMENT_OPTION_BANK,
  PAYMENT_OPTION_CASH,
  PAYMENT_OPTION_ONLINE,
  setPaymentMethod
} from './actions';
import {
  SHIPPING_METHOD_OWN,
  SHIPPING_TYPE_LOCAL_PICKUP
} from '../../components/ShippingCard/actions';
import {
  ADDRESS_EMAIL, setAddressFields
} from '../../components/AddressCard/actions';
import {useDispatch} from "react-redux";

export default function PaymentOptions(props) {

  const dispatch = useDispatch();
  const {paymentOption, shippingMethod, shippingType, emailField} = props;

  const [state, setState] = React.useState(
      {
        errors: {}
      } );

  useEffect(() => {
    if ( typeof paymentOption === 'undefined' ||
        paymentOption === '0' ||
        paymentOption === PAYMENT_OPTION_CASH &&
        !(shippingMethod === SHIPPING_METHOD_OWN.key && shippingType === SHIPPING_TYPE_LOCAL_PICKUP) ) {
      setMethod(PAYMENT_OPTION_ONLINE);
    }
    saveField(emailField);
    }, []);

  function handleChange(e, { value }){
    setMethod( value );
  }

  function setMethod(newMethod) {
    dispatch(setPaymentMethod( newMethod ));
  }

function setField(e) {
    saveField(e.target.value);
  }

  function saveField(fieldValue) {
      let errors = {};

      if (fieldValue === '') {
        errors[ADDRESS_EMAIL] = 'это поле обязательно для заполнения';
      } else {
        const lastAtPos = emailField.lastIndexOf('@');
        const lastDotPos = emailField.lastIndexOf('.');
        if (
          !(
            lastAtPos < lastDotPos && lastAtPos > 0 &&
            fieldValue.indexOf('@@') === -1 && lastDotPos > 2 &&
            fieldValue.length - lastDotPos > 2
          )
        ) {
          errors[ADDRESS_EMAIL] = 'неверный формат эл. почты';
        }
      }

      setState({ ...state, errors });

      if (emailField !== fieldValue) {
        const fields = {};
        fields[ADDRESS_EMAIL] = fieldValue;
        dispatch(setAddressFields(fields));
      }
  }

    return (
      <Form>
        <Form.Field>
          <Radio
            label='онлайн'
            name='radioGroup'
            value={PAYMENT_OPTION_ONLINE}
            checked={paymentOption === PAYMENT_OPTION_ONLINE}
            onChange={handleChange}
            color='blue'
          />
          <Label as='a' className="label-payment-option-inline" image>
            <img alt="" src='https://e-feed.ru/wp-content/plugins/tinkoff-woocommerce/tinkoff/tinkoff.png'/>
          </Label>
          <Label as='a' className="label-payment-option">
            на странице банка через карту, QR-код, СБЕР
          </Label>
        </Form.Field>
        <Form.Field>
          <Radio
            label='б/нал на банковский счет'
            name='radioGroup'
            value={PAYMENT_OPTION_BANK}
            checked={paymentOption === PAYMENT_OPTION_BANK}
            onChange={handleChange}
            color='blue'
          />
          <Label as='a' className="label-payment-option">
            по реквизитам счета или QR-кодом, счет отправим после создания заказа по эл. почте
          </Label>
          { paymentOption === PAYMENT_OPTION_BANK ?
          <React.Fragment>
            <Input
              name={ADDRESS_EMAIL}
              icon='mail'
              iconPosition='left'
              placeholder='введите адрес электронной почты'
              fluid
              transparent
              className='payment-option-email'
              color='blue'
              value={emailField}
              onChange={setField}
            />
            <span className="shipping-field-error">{state.errors[ADDRESS_EMAIL]}</span>
          </React.Fragment> : '' }
        </Form.Field>
        { shippingMethod === SHIPPING_METHOD_OWN.key && shippingType === SHIPPING_TYPE_LOCAL_PICKUP ?
          <Form.Field>
            <Radio
              label='Оплата при получении'
              name='radioGroup'
              value={PAYMENT_OPTION_CASH}
              checked={paymentOption === PAYMENT_OPTION_CASH}
              onChange={handleChange}
              color='blue'
            />
            <Label as='a' className="label-payment-option">
              наличными в пункте выдачи при получении заказа
            </Label>
          </Form.Field>
         : ''}
      </Form>
    );
}
